import { render, staticRenderFns } from "./agreement_shssc.vue?vue&type=template&id=bd7b09bc&scoped=true"
import script from "./agreement_shssc.vue?vue&type=script&lang=js"
export * from "./agreement_shssc.vue?vue&type=script&lang=js"
import style0 from "./agreement_shssc.vue?vue&type=style&index=0&id=bd7b09bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7b09bc",
  null
  
)

export default component.exports